import { render } from "./Physic.vue?vue&type=template&id=524dff56&scoped=true&ts=true"
import script from "./Physic.vue?vue&type=script&lang=ts"
export * from "./Physic.vue?vue&type=script&lang=ts"

import "./Physic.vue?vue&type=style&index=0&id=524dff56&scoped=true&lang=css"
import "./Physic.vue?vue&type=style&index=1&id=524dff56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524dff56"]])

export default __exports__